// @flow
import * as React from 'react';

import type { Element } from 'react';
import { Carousel as ReactResponsiveCarousel } from 'react-responsive-carousel';
import type { Props } from './types';

import { StyledCover } from './styles';

import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ReactResponsiveCarouselProps = {
  showThumbs: false,
  showArrows: false,
  showStatus: false,
  centerMode: true,
  infiniteLoop: false,
  selectedItem: 1
};

const Carousel = ({
  children,
  bottomArrows,
  activeColor,
  arrowType,
  ...restProps
}: Props): Element<any> => (
  <StyledCover arrowType={arrowType} bottomArrows={bottomArrows} activeColor={activeColor}>
    <ReactResponsiveCarousel {...ReactResponsiveCarouselProps} {...restProps}>
      {children}
    </ReactResponsiveCarousel>
  </StyledCover>
);

export default Carousel;
